import moment from "moment";
import { CiLocationOn } from "react-icons/ci";
import { FaArrowRight } from "react-icons/fa6";
import { IoClose } from "react-icons/io5";
import { UserBooking } from "../../APIService/UserBookingService";
import { BookingCardAction } from "./work_place";
import { useTranslation } from "react-i18next";
import BookingActionButton from "../BookingActionButton/BookingActionButton";

type BookingCardProps = {
    booking: UserBooking;
    theme: string | null;
    onAction: (type: BookingCardAction) => void;
}

const BookingCard = ({ booking, theme, onAction }: BookingCardProps) => {

    const { t } = useTranslation();

    // const getActionShadow = (actions:any) => {
    //     if((actions.CheckIn && actions.Cancel) || actions.CheckIn) //Meeting Not Started and can be CheckIn
    //     {
    //         return "0 0 1px 0.5px rgba(255, 170, 0, 0.5)";
    //     }
    //     if(actions.Cancel || actions.Extend) //Future meeting can only be cancelled
    //     {
    //         return "0 0 1px 0.5px rgba(110, 109, 109, 0.5)"
    //     }
    //     if(actions.CheckOut) //Meeting Started and can be CheckOut
    //     {
    //         return "0 0 1px 0.5px rgba(255, 0, 80, 0.5)"
    //     }
    //     return "0 0 1px 0.5px rgba(255, 255, 255, 0)" // for default if nothing is true in actions
    // }

    const getActionShadow = () => {
        const now = moment();
        const noShadow = "0 0 1px 0.5px rgba(255, 255, 255, 0)";

        const start = moment(booking.Start);
        const end = moment(booking.End);
        const startIn = booking.StartIn ? moment(booking.StartIn) : null;
        const endsIn = booking.EndsIn ? moment(booking.EndsIn) : null;

        // Only today
        if (!start.isSame(now, 'day')) {
            return noShadow;
        }

        // 1️⃣ ENDED → no shadow
        if (endsIn) {
            return noShadow;
        }

        // 2️⃣ STARTED → red shadow
        if (startIn) {
            return "0 0 1px 0.5px rgba(255, 0, 80, 0.5)";
        }

        // 3️⃣ NOT STARTED → within 30 minutes only
        if (now.isBefore(start)) {
            const minutesToStart = start.diff(now, 'minutes');

            if (minutesToStart > 30) {
                return noShadow;
            }

            return "0 0 1px 0.5px rgba(255, 170, 0, 0.5)";
        }

        return noShadow;
    };

    // const getMeetingStatus = () => {
    //     const today = new Date();
    //     if (booking.StartIn !== null && moment(booking.StartIn).isSame(moment(), 'day')) {
    //         return `Starting in ${booking.StartIn} minutes`
    //     } else if (booking.EndsIn !== null && !moment(booking.EndsIn).isBefore(moment(new Date())) && moment(booking.EndsIn).isSame(moment(), 'day')) {
    //         return `Ending in ${booking.EndsIn} minutes`
    //     } else if (booking.Start !== null && moment(booking.Start).isAfter(moment(booking.End))) {
    //         return `Starts at ${moment(booking.Start).format("HH:mm")}`
    //     }  else if (booking.End !== null && moment(booking.EndsIn).isBefore(moment(new Date()))) {
    //         return `Ends at ${moment(booking.End).format("HH:mm")}`
    //     } else {
    //         return `Ended at ${moment(booking.End).format("HH:mm")}`
    //     }
    // }

    const getMeetingStatus = () => {
        const now = moment();

        const start = moment(booking.Start);
        const end = moment(booking.End);
        const startIn = booking.StartIn ? moment(booking.StartIn) : null;
        const endsIn = booking.EndsIn ? moment(booking.EndsIn) : null;

        // Only today
        if (!start.isSame(now, 'day')) {
            return null;
        }

        // 1️⃣ ENDED (highest priority)
        if (endsIn) {
            return `Ended at ${endsIn.format('HH:mm a')}`;
        }

        // 2️⃣ STARTED
        if (startIn) {
            const minutes = end.diff(now, 'minutes');
            return minutes > 0
                ? `Ending in ${minutes} minutes`
                : 'Ending now';
        }

        // 3️⃣ NOT STARTED
        if (now.isBefore(start)) {
            const minutes = start.diff(now, 'minutes');
            return `Starting in ${minutes} minutes`;
        }

        return null;
    };

    const meetingStatus = getMeetingStatus();

    return (
        <>
            <div className="rounded w-100 p-2 d-flex flex-column gap-2" style={{ border: theme === "dark" ? "1px solid #525252ff" : "2px solid #e8e8e8ff", boxShadow: getActionShadow() }}>
                <div className="d-flex justify-content-between align-items-center">
                    <span className="px-2 py-1 rounded-1" style={{ backgroundColor: meetingStatus ? '#303030' : 'transparent', color: 'white' }}>
                        {meetingStatus}
                    </span>
                    <div className='d-flex gap-2'>
                        {
                            booking.Actions.CheckIn &&
                            <BookingActionButton
                                theme={theme ?? "light"}
                                icon={'/checkin.svg'}
                                label={t('CheckIn')}
                                bgColor="#FFAE00"
                                onClick={() => onAction(BookingCardAction.CheckIn)}
                            />
                        }
                        {
                            booking.Actions.CheckOut &&
                            <BookingActionButton
                                theme={theme ?? "light"}
                                icon={'/checkout.svg'}
                                label={t('CheckOut')}
                                bgColor="#FF5252"
                                onClick={() => onAction(BookingCardAction.CheckOut)}
                            />

                        }
                        {
                            booking.Actions.Cancel &&
                            <div className="action-button rounded-2 p-1 align-items-center justify-content-center" style={{ cursor: 'pointer', border: theme === 'dark' ? "1px dashed white" : "1px dashed black", color: theme === 'dark' ? '#ffffff' : '#000000' }} onClick={() => onAction(BookingCardAction.Cancel)}>
                                <IoClose size="18" />
                                <span className='ps-1'>{t('Cancel')}</span>
                            </div>
                        }
                        {
                            booking.Actions.Extend &&
                            <BookingActionButton
                                theme={theme ?? "light"}
                                icon={theme === 'dark' ? '/extend_btn/light.svg' : '/extend_btn/dark.svg'}
                                label={t('Extend')}
                                bgColor="#0066FF"
                                onClick={() => { }}
                            />
                        }
                    </div>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                    <span className="px-1 py-1 fw-bold" style={{ fontSize: 14 }}>
                        {booking.Subject}
                    </span>
                    <span className="" style={{ fontSize: 14 }}>
                        {moment(booking?.Start).format("HH:mm")}
                        {' '}-{' '}
                        {moment(booking?.End).format("HH:mm")}
                    </span>
                </div>

                <div className="d-flex justify-content-between align-items-center">
                    <span className="px-1" style={{ color: "#abababff" }}>
                        {booking.Resource?.Name}
                    </span>
                    <div className="ps-2" style={{ cursor: 'pointer', color: "#abababff" }}>
                        <CiLocationOn size="20" />
                    </div>
                </div>
            </div>
        </>
    )
}

export default BookingCard;